"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  default: () => src_default,
  isSameHost: () => isSameHost,
  isSamePageAnchor: () => isSamePageAnchor,
  startHolyLoader: () => startHolyLoader,
  stopHolyLoader: () => stopHolyLoader,
  toAbsoluteURL: () => toAbsoluteURL
});
module.exports = __toCommonJS(src_exports);
var React = __toESM(require("react"));

// src/constants.ts
var DEFAULTS = {
  color: "#59a2ff",
  initialPosition: 0.08,
  height: 4,
  easing: "ease",
  speed: 200,
  zIndex: 2147483647,
  showSpinner: false,
  boxShadow: void 0
};
var START_HOLY_EVENT = "holy-progress-start";
var STOP_HOLY_EVENT = "holy-progress-stop";

// src/HolyProgress.ts
var _HolyProgress = class _HolyProgress {
  /**
   * Create a HolyProgress instance.
   * @param {Partial<HolyProgressProps>} [customSettings] - Optional custom settings to override defaults.
   */
  constructor(customSettings) {
    /**
     * Sets the progress to a specific value.
     * @private
     * @param {number} n - The new progress value (0 to 1).
     * @returns {HolyProgress} The current instance for chaining methods.
     */
    this.setTo = /* @__PURE__ */ __name((n) => {
      const isStarted = typeof this.status === "number";
      n = this.clamp(n, this.settings.initialPosition, 1);
      this.status = n === 1 ? null : n;
      const progress = this.getOrCreateBar(!isStarted);
      if (progress === null) {
        return this;
      }
      const speed = this.settings.speed;
      this.repaint(progress);
      this.queue((next) => {
        const css = this.barPositionCSS(n);
        if (this.bar === null) {
          return;
        }
        Object.assign(this.bar.style, css, {
          transition: `all ${speed}ms ${this.settings.easing}`
        });
        if (n === 1) {
          progress.style.transition = "none";
          progress.style.opacity = "1";
          this.repaint(progress);
          setTimeout(() => {
            progress.style.transition = "all " + speed + "ms linear";
            progress.style.opacity = "0";
            setTimeout(() => {
              this.removeBar();
              next();
            }, speed);
            this.removeSpinner();
          }, speed);
        } else {
          setTimeout(next, speed);
        }
      });
      return this;
    }, "setTo");
    /**
     * Clamps a number within the inclusive range specified by the given minimum and maximum.
     * @private
     * @param {number} n - The number to clamp.
     * @param {number} min - The lower boundary of the output range.
     * @param {number} max - The upper boundary of the output range.
     * @returns {number} The clamped value.
     */
    this.clamp = /* @__PURE__ */ __name((n, min, max) => {
      if (n < min)
        return min;
      if (n > max)
        return max;
      return n;
    }, "clamp");
    /**
     * Triggers a repaint on the specified HTML element.
     * This function is used to ensure that CSS transitions are properly triggered.
     * @private
     * @param {HTMLElement} obj - The HTML element to repaint.
     * @returns {HTMLElement} The same HTML element, for chaining.
     */
    this.repaint = /* @__PURE__ */ __name((obj) => {
      void obj.offsetWidth;
      return obj;
    }, "repaint");
    /**
     * Converts a progress value (0 to 1) into a percentage representation.
     * Used for calculating the visual width of the progress bar.
     * @private
     * @param {number} n - The progress value to convert.
     * @returns {number} The percentage representation of the progress value.
     */
    this.toBarPercentage = /* @__PURE__ */ __name((n) => {
      return (-1 + n) * 100;
    }, "toBarPercentage");
    /**
     * Initiates the progress bar's movement. If already started, it continues from the current position.
     * Automatically handles automatic incrementation ('trickle') if enabled.
     * @public
     * @returns {HolyProgress} The current instance for chaining methods.
     */
    this.start = /* @__PURE__ */ __name(() => {
      if (this.status === null) {
        this.setTo(0);
        this.startTrickle();
        if (this.settings.showSpinner === true) {
          this.createSpinner();
        }
      }
      return this;
    }, "start");
    /**
     * Performs automatic incrementation of the progress bar.
     * This function is recursive and continues to increment the progress at intervals defined by `speed`.
     * @private
     */
    this.startTrickle = /* @__PURE__ */ __name(() => {
      const run = /* @__PURE__ */ __name(() => {
        if (this.status === null)
          return;
        this.increment();
        setTimeout(run, this.settings.speed);
      }, "run");
      setTimeout(run, this.settings.speed);
    }, "startTrickle");
    /**
     * Completes the progress, moving it to 100%
     * @public
     * @returns {HolyProgress} The current instance for chaining methods.
     */
    this.complete = /* @__PURE__ */ __name(() => this.setTo(1), "complete");
    /**
     * Calculates an increment value based on the current status of the progress.
     * This is used to determine the amount of progress to add during automatic incrementation.
     * @private
     * @param {number} status - The current progress status.
     * @returns {number} The calculated increment value.
     */
    this.calculateIncrement = /* @__PURE__ */ __name((status) => {
      const base = 0.1;
      const scale = 5;
      return base * Math.exp(-scale * status);
    }, "calculateIncrement");
    /**
     * Increments the progress bar by a specified amount, or by an amount determined by `calculateIncrement` if not specified.
     * @private
     * @param {number} [amount] - The amount to increment the progress bar.
     * @returns {HolyProgress} The current instance for chaining methods.
     */
    this.increment = /* @__PURE__ */ __name((amount) => {
      if (this.status === null) {
        return this.start();
      }
      if (this.status > 1) {
        return this;
      }
      if (typeof amount !== "number") {
        amount = this.calculateIncrement(this.status);
      }
      this.status = this.clamp(this.status + amount, 0, 0.994);
      return this.setTo(this.status);
    }, "increment");
    /**
     * A function to manage the queue of operations to be performed on the progress bar.
     * It ensures that operations are executed in sequence.
     * @private
     * @returns {Function} A function that accepts a callback to be queued.
     */
    this.queue = /* @__PURE__ */ (() => {
      const pending = [];
      const next = /* @__PURE__ */ __name(() => {
        const fn = pending.shift();
        if (fn !== void 0) {
          fn(next);
        }
      }, "next");
      return (fn) => {
        pending.push(fn);
        if (pending.length === 1)
          next();
      };
    })();
    /**
     * Creates and initializes a new progress bar element in the DOM.
     * It sets up the necessary styles and appends the element to the document body.
     * @private
     * @param {boolean} fromStart - Indicates if the bar is created from the start position.
     * @returns {HTMLElement | null} The created progress bar element, or null if creation fails.
     */
    this.createBar = /* @__PURE__ */ __name((fromStart) => {
      var _a, _b;
      const progress = document.createElement("div");
      progress.id = "holy-progress";
      progress.style.pointerEvents = "none";
      progress.innerHTML = '<div class="bar" role="bar"></div>';
      const bar = progress.querySelector('[role="bar"]');
      if (bar === null) {
        return null;
      }
      this.bar = bar;
      const percentage = fromStart ? "-100" : this.toBarPercentage((_a = this.status) != null ? _a : 0);
      this.bar.style.background = this.settings.color;
      if (typeof this.settings.height === "number") {
        this.bar.style.height = this.settings.height + "px";
      } else {
        this.bar.style.height = this.settings.height;
      }
      this.bar.style.zIndex = this.settings.zIndex.toString();
      this.bar.style.position = "fixed";
      this.bar.style.width = "100%";
      this.bar.style.top = "0";
      this.bar.style.left = "0";
      this.bar.style.transition = "all 0 linear";
      this.bar.style.transform = "translate3d(" + percentage + "%,0,0)";
      this.bar.style.boxShadow = (_b = this.settings.boxShadow) != null ? _b : "";
      document.body.appendChild(progress);
      return progress;
    }, "createBar");
    /**
     * Creates and initializes a new spinner element in the DOM.
     * It sets up the necessary styles and appends the element to the document body.
     * @private
     * @returns {void}
     */
    this.createSpinner = /* @__PURE__ */ __name(() => {
      if (document.getElementById("holy-progress-spinner") !== null) {
        return;
      }
      const spinner = document.createElement("div");
      spinner.id = "holy-progress-spinner";
      spinner.style.pointerEvents = "none";
      spinner.style.display = "block";
      spinner.style.position = "fixed";
      spinner.style.zIndex = this.settings.zIndex.toString();
      spinner.style.top = "15px";
      spinner.style.right = "15px";
      spinner.style.width = "18px";
      spinner.style.height = "18px";
      spinner.style.boxSizing = "border-box";
      spinner.style.border = "solid 2px transparent";
      spinner.style.borderTopColor = this.settings.color;
      spinner.style.borderLeftColor = this.settings.color;
      spinner.style.borderRadius = "50%";
      spinner.style.animation = "holy-progress-spinner 400ms linear infinite";
      const keyframes = `
      @keyframes holy-progress-spinner {
        0%   { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
      const style = document.createElement("style");
      style.innerHTML = keyframes;
      spinner.appendChild(style);
      document.body.appendChild(spinner);
    }, "createSpinner");
    /**
     * Retrieves the existing progress bar element from the DOM, or creates a new one if not present.
     * @private
     * @param {boolean} fromStart - Indicates if the bar should be retrieved/created from the start position.
     * @returns {HTMLElement | null} The retrieved or newly created progress bar element.
     */
    this.getOrCreateBar = /* @__PURE__ */ __name((fromStart) => {
      const bar = document.getElementById("holy-progress");
      if (bar !== null) {
        return bar;
      }
      return this.createBar(fromStart);
    }, "getOrCreateBar");
    /**
     * Removes the progress bar element from the DOM.
     * @private
     * @returns {void}
     */
    this.removeBar = /* @__PURE__ */ __name(() => {
      const bar = document.getElementById("holy-progress");
      bar !== null && bar.remove();
    }, "removeBar");
    /**
     * Removes the spinner element from the DOM.
     * @private
     * @returns {void}
     */
    this.removeSpinner = /* @__PURE__ */ __name(() => {
      const spinner = document.getElementById("holy-progress-spinner");
      spinner !== null && spinner.remove();
    }, "removeSpinner");
    /**
     * Determines the most suitable CSS positioning strategy based on browser capabilities.
     * Checks for transform properties with vendor prefixes and standard un-prefixed properties.
     * @private
     * @returns {TransformStrategy} - The optimal CSS positioning strategy ('translate3d', 'translate', or 'margin').
     */
    this.getTransformStrategy = /* @__PURE__ */ __name(() => {
      const style = document.body.style;
      const prefixes = ["Webkit", "Moz", "ms", "O", ""];
      let transformProp = "";
      for (let i = 0; i < prefixes.length; i++) {
        if (`${prefixes[i]}Transform` in style) {
          transformProp = prefixes[i];
          break;
        }
      }
      if (transformProp !== "" && `${transformProp}Perspective` in style) {
        return "translate3d";
      } else if (transformProp !== "") {
        return "translate";
      } else {
        return "margin";
      }
    }, "getTransformStrategy");
    /**
     * Generates the CSS for the progress bar position based on the detected positioning strategy.
     * Dynamically sets the transform or margin-left properties for the bar's position.
     * @private
     * @param {number} n - Position value of the bar, as a number between 0 and 1.
     * @returns {Object} - CSS styles for the progress bar.
     */
    this.barPositionCSS = /* @__PURE__ */ __name((n) => {
      const transformStrategy = this.getTransformStrategy();
      const barPosition = this.toBarPercentage(n) + "%";
      if (transformStrategy === "translate3d") {
        return { transform: `translate3d(${barPosition},0,0)` };
      }
      if (transformStrategy === "translate") {
        return { transform: `translate(${barPosition},0)` };
      }
      return { marginLeft: barPosition };
    }, "barPositionCSS");
    const defaultSettings = {
      initialPosition: DEFAULTS.initialPosition,
      easing: DEFAULTS.easing,
      speed: DEFAULTS.speed,
      color: DEFAULTS.color,
      height: DEFAULTS.height,
      zIndex: DEFAULTS.zIndex,
      boxShadow: DEFAULTS.boxShadow,
      showSpinner: DEFAULTS.showSpinner
    };
    this.settings = __spreadValues(__spreadValues({}, defaultSettings), customSettings);
    this.status = null;
    this.bar = null;
  }
};
__name(_HolyProgress, "HolyProgress");
var HolyProgress = _HolyProgress;

// src/index.tsx
var toAbsoluteURL = /* @__PURE__ */ __name((url) => {
  return new URL(url, window.location.href).href;
}, "toAbsoluteURL");
var isSamePageAnchor = /* @__PURE__ */ __name((currentUrl, newUrl) => {
  const current = new URL(toAbsoluteURL(currentUrl));
  const next = new URL(toAbsoluteURL(newUrl));
  return current.href.split("#")[0] === next.href.split("#")[0];
}, "isSamePageAnchor");
var isSameHost = /* @__PURE__ */ __name((currentUrl, newUrl) => {
  const current = new URL(toAbsoluteURL(currentUrl));
  const next = new URL(toAbsoluteURL(newUrl));
  return current.hostname.replace(/^www\./, "") === next.hostname.replace(/^www\./, "");
}, "isSameHost");
var startHolyLoader = /* @__PURE__ */ __name(() => {
  document.dispatchEvent(new Event(START_HOLY_EVENT));
}, "startHolyLoader");
var stopHolyLoader = /* @__PURE__ */ __name(() => {
  document.dispatchEvent(new Event(STOP_HOLY_EVENT));
}, "stopHolyLoader");
var HolyLoader = /* @__PURE__ */ __name(({
  color = DEFAULTS.color,
  initialPosition = DEFAULTS.initialPosition,
  height = DEFAULTS.height,
  easing = DEFAULTS.easing,
  speed = DEFAULTS.speed,
  zIndex = DEFAULTS.zIndex,
  boxShadow = DEFAULTS.boxShadow,
  showSpinner = DEFAULTS.showSpinner
}) => {
  const holyProgressRef = React.useRef(null);
  React.useEffect(() => {
    const startProgress = /* @__PURE__ */ __name(() => {
      if (holyProgressRef.current === null) {
        return;
      }
      try {
        holyProgressRef.current.start();
      } catch (error) {
      }
    }, "startProgress");
    const stopProgress = /* @__PURE__ */ __name(() => {
      if (holyProgressRef.current === null) {
        return;
      }
      try {
        holyProgressRef.current.complete();
      } catch (error) {
      }
    }, "stopProgress");
    let isHistoryPatched = false;
    const stopProgressOnHistoryUpdate = /* @__PURE__ */ __name(() => {
      if (isHistoryPatched) {
        return;
      }
      const originalPushState = history.pushState.bind(history);
      history.pushState = (...args) => {
        stopProgress();
        originalPushState(...args);
      };
      const originalReplaceState = history.replaceState.bind(history);
      history.replaceState = (...args) => {
        stopProgress();
        originalReplaceState(...args);
      };
      isHistoryPatched = true;
    }, "stopProgressOnHistoryUpdate");
    const handleClick = /* @__PURE__ */ __name((event) => {
      try {
        const target = event.target;
        const anchor = target.closest("a");
        if (anchor === null || anchor.target === "_blank" || event.ctrlKey || event.metaKey || // Skip if URL points to a different domain
        !isSameHost(window.location.href, anchor.href) || // Skip if URL is a same-page anchor (href="#", href="#top", etc.).
        isSamePageAnchor(window.location.href, anchor.href) || // Skip if URL uses a non-http/https protocol (mailto:, tel:, etc.).
        !toAbsoluteURL(anchor.href).startsWith("http")) {
          return;
        }
        startProgress();
      } catch (error) {
        stopProgress();
      }
    }, "handleClick");
    try {
      if (holyProgressRef.current === null) {
        holyProgressRef.current = new HolyProgress({
          color,
          height,
          initialPosition,
          easing,
          speed,
          zIndex,
          boxShadow,
          showSpinner
        });
      }
      document.addEventListener("click", handleClick);
      document.addEventListener(START_HOLY_EVENT, startProgress);
      document.addEventListener(STOP_HOLY_EVENT, stopProgress);
      stopProgressOnHistoryUpdate();
    } catch (error) {
    }
    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener(START_HOLY_EVENT, startProgress);
      document.removeEventListener(STOP_HOLY_EVENT, stopProgress);
    };
  }, [holyProgressRef]);
  return null;
}, "HolyLoader");
var src_default = HolyLoader;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isSameHost,
  isSamePageAnchor,
  startHolyLoader,
  stopHolyLoader,
  toAbsoluteURL
});
//# sourceMappingURL=index.js.map